// import { Button } from "../Button";
// import AddIcon from "../../assets/img/icons/add.svg";
// import ScheduleIcon from "../../assets/img/icons/schedule.svg";
import { StyledUnitFooter } from "../../styles/StyledUnit";

export default function MeetingFooter() {
	return (
		<StyledUnitFooter>
			{/* <Button icon={AddIcon}>Add document</Button>
			<Button icon={ScheduleIcon}>Schedule a meeting</Button> */}
		</StyledUnitFooter>
	);
}
